module.exports = __webpack_public_path__ + "./fonts/PPAgrandir-WideBlackItalic.otf";